import { GENERIC_PROFILE_SLUG } from '@hearth/shared';
import { useQuery } from '@tanstack/react-query';
import { Link, createFileRoute } from '@tanstack/react-router';
import { ArrowLeft, Gamepad2 } from 'lucide-react';
import { GameProfileEditor } from '@/components/game-profile-editor';
import { PageHeader } from '@/components/page-header';
import { QueryState } from '@/components/query-state';
import { Button } from '@/components/ui/button';
import { gameProfilesQuery } from '@/lib/admin-queries';
import { profileJson } from '@/lib/profile-json';

export const Route = createFileRoute('/_app/admin/game-profiles/new')({
  component: NewGameProfile,
});

function NewGameProfile() {
  const query = useQuery(gameProfilesQuery);
  return (
    <>
      <Button asChild variant="ghost" size="sm" className="mb-4 -ml-2">
        <Link to="/admin/game-profiles">
          <ArrowLeft /> Game profiles
        </Link>
      </Button>
      <PageHeader
        title="New game profile"
        icon={Gamepad2}
        description="Starts from the generic profile. Give it a slug, a name and rules that pick its eggs."
      />
      <QueryState query={query}>
        {(profiles) => {
          // The generic profile is always there (the API seeds the built-ins on first use).
          const generic = profiles.find((p) => p.slug === GENERIC_PROFILE_SLUG)!;
          const initial = profileJson({
            definition: {
              ...generic.definition,
              slug: 'my-game',
              identity: { ...generic.definition.identity, name: 'My game' },
            },
            match: [{ eggName: '^My Game$' }],
            priority: 10,
          });
          return <GameProfileEditor profile={null} initial={initial} />;
        }}
      </QueryState>
    </>
  );
}
